import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  templateUrl: './choose-bank.component.html',
  styleUrls: ['./choose-bank.component.scss']
})
export class ChooseBankComponent implements OnInit {

  private clientId: number;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute) {
  }


  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => this.clientId = params['clientId']);
  }

  route(bank: string) {
    this.router.navigate(['/bewind/' + this.clientId + '/importeren/' + bank]);
  }
}
